export const PictureFrame = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-5 border border-white/15">
    <span className="absolute -left-px -top-px h-5 w-5 border-l border-t border-signal" />
    <span className="absolute -bottom-px -right-px h-5 w-5 border-b border-r border-signal" />
  </div>
);
